{
  "tabs": {
    "chat": "Spjall",
    "reminders": "Áminningar",
    "calendar": "Dagatal",
    "settings": "Stillingar"
  },
  "common": {
    "cancel": "Hætta við",
    "save": "Vista",
    "confirm": "Staðfesta",
    "delete": "Eyða",
    "back": "Til baka",
    "close": "Loka",
    "edit": "Breyta",
    "search": "Leita",
    "all": "Allt",
    "loading": "Hleð...",
    "error": "Eitthvað fór úrskeiðis",
    "notFound": "Ekkert fannst",
    "tryAgain": "Vinsamlegast reyndu aftur",
    "retry": "Reyna aftur",
    "undo": "Afturkalla",
    "pullToRefresh": "Dragðu til að endurnýja",
    "justNow": "rétt núna"
  },
  "auth": {
    "welcome": "Velkomin(n) í FishMemory",
    "tagline": "Þinn WhatsApp áminningaaðstoðarmaður, nú í vasanum þínum.",
    "subtitle": "Þinn WhatsApp áminningaaðstoðarmaður, nú í vasanum þínum.",
    "phoneLabel": "WhatsApp númerið þitt",
    "phoneHint": "Við sendum staðfestingarkóða í gegnum WhatsApp",
    "invalidPhone": "Vinsamlegast sláðu inn gilt símanúmer",
    "continue": "Halda áfram",
    "enterPhone": "Sláðu inn WhatsApp númerið þitt",
    "phonePlaceholder": "Símanúmer",
    "sendCode": "Senda kóða",
    "verifyTitle": "Staðfesta númerið þitt",
    "otpSentTo": "6 stafa kóði var sendur á {{phone}} í gegnum WhatsApp",
    "enterFullCode": "Vinsamlegast sláðu inn alla 6 stafi",
    "invalidOtp": "Ógildur kóði. Reyndu aftur.",
    "otpFailed": "Mistókst að senda kóða. Reyndu aftur.",
    "otpResent": "Kóði sendur aftur",
    "resendIn": "Endursenda eftir {{seconds}}s",
    "resendCode": "Endursenda kóða",
    "enterOtp": "Sláðu inn kóðann sem var sendur á WhatsApp",
    "verify": "Staðfesta",
    "resend": "Endursenda kóða",
    "wrongNumber": "Rangt númer?",
    "backToPhone": "Til baka að símanúmeri",
    "editPhone": "Breyta símanúmeri",
    "error": "Villa",
    "setupTitle": "Við skulum koma þessu í lag",
    "setupSubtitle": "Þú getur alltaf breytt þessu síðar í Stillingum",
    "namePlaceholder": "Nafn þitt",
    "letsGo": "Klára uppsetningu",
    "skipForNow": "Sleppa núna"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Sláðu inn skilaboð...",
    "inputPlaceholder": "Sláðu inn skilaboð...",
    "typing": "FishMemory er að skrifa...",
    "online": "Á netinu",
    "connecting": "Tengist...",
    "reconnecting": "Endurtenging...",
    "offline": "Ótengdur",
    "empty": "Byrjaðu samtal",
    "emptyHint": "Búðu til áminningar, skoðaðu dagatalið eða biððu um hjálp.",
    "emptyAction": "Senda sýnidæmi áminningar",
    "actions": "Aðgerðir í spjalli",
    "keep": "Geyma skilaboð",
    "clearTitle": "Hreinsa spjall",
    "clearConfirm": "Eyða öllum skilaboðum af þessum tæki? Þetta er óafturkræft.",
    "clear": "Hreinsa spjall",
    "optionSelected": "Valið: {{label}}",
    "sendingSelection": "Sendi...",
    "connectionLost": "Endurtenging..."
  },
  "reminders": {
    "title": "Áminningar mínar",
    "active": "Virk",
    "today": "Í dag",
    "thisWeek": "Þessa viku",
    "history": "Saga",
    "items": "atriði",
    "emptyTitle": "Engar áminningar ennþá",
    "emptySubtitle": "Búðu til eina úr spjalli og hún birtist hér.",
    "emptyAction": "Opna spjall",
    "filterActive": "Virk",
    "filterToday": "Í dag",
    "filterWeek": "Þessa viku",
    "filterHistory": "Saga",
    "emptyState": "Engar áminningar ennþá. Byrjaðu að spjalla!",
    "swipeDone": "Lokið",
    "swipeSnooze": "Seinka",
    "swipeDelete": "Eyða",
    "search": "Leita að áminningum...",
    "upcoming": "Komandi",
    "completed": "Lokið",
    "overdue": "Sein",
    "tomorrow": "Á morgun",
    "synced": "Samstillt {{value}}",
    "swipeHint": "Strjúktu áminningu til að sjá fleiri aðgerðir",
    "noResults": "Engar áminningar sem passa leitina",
    "noResultsHint": "Reyndu annað leitarorð eða hreinsaðu leit",
    "deleteAllFailed": "Mistókst að eyða öllum áminningum"
  },
  "calendar": {
    "title": "Dagatal",
    "today": "Í dag",
    "tomorrow": "Á morgun",
    "completed": "lokið",
    "noEvents": "Ekkert skráð",
    "noEventsSubtitle": "Veldu dagsetningu til að sjá áminningar og viðburði.",
    "googleEvent": "Google Dagatal",
    "legendActive": "Virk",
    "legendRecurring": "Endurtekin",
    "legendDone": "Lokið",
    "legendGoogle": "Google",
    "previousMonth": "Fyrri mánuður",
    "nextMonth": "Næsti mánuður",
    "previousYear": "Fyrra ár",
    "nextYear": "Næsta ár",
    "goToToday": "Fara í dag",
    "all": "Allt",
    "active": "Virk",
    "done": "Lokið",
    "paused": "Stoppuð"
  },
  "settings": {
    "title": "Stillingar",
    "profile": "Prófíll",
    "name": "Birtingarnafn",
    "enterName": "Sláðu inn nafn",
    "language": "Tungumál",
    "uiLanguage": "Forritstungumál",
    "uiLanguageHelp": "Breyta tungumáli í forritinu, dagatalsmerkjum og útlitsháttum á þessu tæki eingöngu.",
    "serverLanguage": "Tungumál spjalls",
    "serverLanguageHelp": "Breyta tungumáli sem notað er í svörum þjóns og áminningum fyrir reikninginn þinn.",
    "timezone": "Tímabelti",
    "currentTimezone": "Núverandi tímabelti",
    "timezoneHelp": "Öll áminningartími eru sýnd með þessu tímabelti.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Vista tímabelti",
    "timezoneSaved": "Tímabelti uppfært",
    "detect": "Greina",
    "detectFailed": "Tókst ekki að greina tímabelti",
    "autoDetect": "Sjálfvirk greining úr GPS",
    "notifications": "Tilkynningar",
    "notificationsHelp": "Eftirfylgnaráminningar stjórna endurteknu áminningum eftir að áminning hefur verið afhent. Leyfi fyrir tilkynningum eru enn stjórnað í síma-stillingum.",
    "pushEnabled": "Ýta tilkynningum",
    "autoDoneOnFire": "Merkja sjálfkrafa lokið þegar áminning fer af stað",
    "autoDoneOnFireDesc": "Ef slökkt, þá eru áminningar virkar þar til þú merkir þær lokið.",
    "googleCalendar": "Google Dagatal",
    "google": "Google Dagatal",
    "googleConnected": "Tengt",
    "googleDisconnected": "Ekki tengt",
    "googleConnectedHelp": "Nýjar áminningar geta verið samstilltar við dagatalið þitt sjálfkrafa.",
    "googleDisconnectedHelp": "Tengdu Google Dagatal til að halda áminningum og viðburðum samstilltum.",
    "googleConnectFailed": "Mistókst að tengja Google Dagatal",
    "connected": "Tengt",
    "disconnected": "Ekki tengt",
    "connect": "Tengja",
    "disconnect": "Aftengja",
    "autoSync": "Sjálfvirk samstilling nýrra áminninga",
    "autosync": "Sjálfvirk samstilling nýrra áminninga",
    "subscription": "Áskrift",
    "trialUsed": "Prófun: {{used}}/{{total}} notuð",
    "trialStatus": "Prófun í boði",
    "activeStatus": "Virk áskrift",
    "expiredStatus": "Áskrift útrunnin",
    "unsubscribedStatus": "Ekki áskrifandi",
    "about": "Um",
    "version": "Útgáfa",
    "logout": "Skrá út",
    "logoutTitle": "Skrá út",
    "logoutConfirm": "Ertu viss um að þú viljir skrá þig út?",
    "noName": "Engin nafn stillt",
    "serverConnection": "Tenging við þjón",
    "serverUrl": "Vefslóð þjóns",
    "serverEdit": "Breyta",
    "saveReconnect": "Vista og tengja aftur",
    "resetDefault": "Endurstilla sjálfgefið",
    "invalidServerUrlTitle": "Ógild vefslóð þjóns",
    "invalidServerUrlMessage": "Sláðu inn gilt http eða https vefslóð þjóns, t.d. https://example.com",
    "uiLanguageChangeFailed": "Mistókst að breyta tungumáli forrits. Reyndu aftur.",
    "serverLanguageChangeFailed": "Mistókst að breyta tungumáli spjalls. Reyndu aftur.",
    "timezoneChangeFailed": "Mistókst að breyta tímabelti. Reyndu aftur.",
    "autoSyncChangeFailed": "Mistókst að uppfæra sjálfvirka samstillingu. Reyndu aftur.",
    "nameChangeFailed": "Mistókst að uppfæra birtingarnafn. Reyndu aftur.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Upplýsingar um áminningu",
    "editTime": "Breyta tíma",
    "rename": "Endurnefna",
    "snooze": "Seinka",
    "snooze15": "Seinka um 15 mínútur",
    "pause": "Stöðva",
    "pauseReminder": "Stöðva áminningu",
    "resume": "Halda áfram",
    "resumeReminder": "Halda áfram áminningu",
    "skip": "Sleppa næstu",
    "skipOccurrence": "Sleppa þessari tilviki",
    "syncGoogle": "Samstilla við Google",
    "delete": "Eyða",
    "deleteTitle": "Eyða áminningu",
    "deleteConfirm": "Þessi áminning verður varanlega eytt.",
    "deleteRecurringTitle": "Eyða endurteknum áminningum",
    "deleteRecurringMessage": "Viltu sleppa þessari tilviki eða eyða allri röðinni?",
    "deleteThisOccurrence": "Sleppa þessari tilviki",
    "deleteEntireSeries": "Eyða allri röð",
    "done": "Lokið",
    "markDone": "Merkja sem lokið",
    "undo": "Endurheimta",
    "undoPrompt": "Viltu hafa hana virk aftur? Endurheimtu hana núna.",
    "recurring": "Endurtekin",
    "nextRun": "Næsta keyrsla",
    "oneTime": "Einnota",
    "pending": "Í bið",
    "sent": "Send",
    "paused": "Stoppuð",
    "active": "Virk",
    "snoozed": "Seinkuð",
    "localTime": "Sýnt í þínu staðartíma",
    "recurrence": "Endurtekning",
    "created": "Búin til",
    "tags": "Merkimiðar",
    "fireCount": "Fjöldi áminninga",
    "actions": "Aðgerðir",
    "none": "Engar",
    "snoozeFailed": "Mistókst að seinka áminningu",
    "pauseFailed": "Mistókst að stöðva áminningu",
    "resumeFailed": "Mistókst að halda áfram áminningu",
    "skipFailed": "Mistókst að sleppa áminningu",
    "doneFailed": "Mistókst að merkja áminningu sem lokið",
    "undoFailed": "Mistókst að endurheimta stöðu áminningar",
    "deleteFailed": "Mistókst að eyða áminningu",
    "rescheduleTitle": "Endurskipuleggja?",
    "rescheduleMsg": "Þessi áminning er of seint. Viltu endurskipuleggja hana?",
    "reschedule15": "Eftir 15 mínútur",
    "reschedule60": "Eftir 1 klukkustund",
    "keepOverdue": "Halda eins og er"
  },
  "onboarding": {
    "slide1Title": "Velkomin(n) í FishMemory",
    "slide1Sub": "Persónulegur áminningaaðstoðarmaður — knúinn af WhatsApp og hannaður fyrir vasann þinn.",
    "slide2Title": "Spjallaðu náttúrulega",
    "slide2Sub": "Sláðu inn áminningar eins og þú hugsar: „Áminn mig að hringja í mömmu á morgun klukkan 15“ — við sjáum um rest.",
    "slide3Title": "Missa aldrei af neinu",
    "slide3Sub": "Fáðu tímanlegar tilkynningar, skipuleggðu með merkjum og haltu utan um allt sem skiptir máli.",
    "getStarted": "Byrjaðu",
    "next": "Næst",
    "firstReminderTitle": "Búðu til fyrstu áminninguna þína!",
    "firstReminderHint": "Reyndu að skrifa eitthvað eins og:",
    "firstReminderExample": "Áminn mig að drekka vatn á morgun klukkan 9",
    "gotIt": "Skil",
    "notifRationaleTitle": "Vertu á réttum tíma",
    "notifRationaleBody": "FishMemory þarf tilkynningar til að minna þig á réttum tíma. Þú færð aðeins tilkynningar fyrir áminningar sem þú býrð til.",
    "notifRationaleAllow": "Virkja tilkynningar",
    "notifRationaleLater": "Kannski síðar",
    "swipeHint": "Strjúktu til hægri fyrir fljótar aðgerðir →",
    "calendarDragHint": "Dragðu til að stækka ↕"
  }
}
